import React from 'react';

const Georgia = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Georgia Specific Terms
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>
          No specific disclosure form; sellers must answer buyer questions
          honestly.
        </li>
        <li>Closing Attorney: Required to conduct real estate closings.</li>
        <li>
          Seller Disclosure Statement: Standard practice, though not mandated by
          law.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2015/09/sellers-disclosure-of-lead-paint.pdf',
                '_blank'
              );
            }}
          >
            Lead-Based Paint Disclosure{' '}
          </span>
          – Only for residences that were built before 1978. This information
          should be available at the County’s Revenue Office.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/08/Georgia-Sellers-Disclosure-Statement.pdf',
                '_blank'
              );
            }}
          >
            Seller's Property Disclosure Statement{' '}
          </span>
          – Though not specifically required by law, sellers must disclose any
          material defects to a potential buyer.
        </li>
      </ol>
    </div>
  );
};

export default Georgia;
